import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import MyTable, { TableRow } from "../../../components/MyTable";
import { SetStateAction, useEffect, useState } from "react";
import { cancelApprovedCoupon, resetCouponsSort, searchEmployeeCoupons, setCancelApprovedCouponData, setCancelApprovedCouponResult, setLoadingCancelApprovedCoupon } from "../../../store/slices/documents";
import { formatDateToTimestamp, getDatestring } from "../../../utils/date";
import { TableHeadRows } from "../../../components/MyTable/TableHead";
import { Button, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Tooltip, Typography } from "@mui/material";
import { EmployeCoupons } from "../../../interfaces/employeeDocuments.interface";
import { setCancelCouponrequest, setCouponsHasAttachmentFlag } from "../../../api/s10DocumentsApi";
import MySnackbar from "../../../components/MySnackbar";
import { DocumentsComponent } from "../../../components/DocumentsComponent";
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { CouponStatus } from "../../../enumns/Coupons";


interface TableCouponsProps {
    numberOfCards?: number;
    startDate?: Date;
    endDate?: Date;
    status?: string;
    changeViewOptionHidden?: boolean;
    hiddenBottomPaginator?: boolean;
    type?: string;
    onlyPendings?: boolean;
    hiddenFilter?: boolean;
}

const getDefaultDate = (months: number) => {
    const newDate = new Date();
    newDate.setMonth(newDate.getMonth() + months);
    return newDate;
}

const TableCoupons = (props: TableCouponsProps) => {
    const {cancelApprovedCouponResult, ...documents} = useSelector((state: RootState) => state.documents);
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const {requestCoupon} = useSelector((state: RootState) => state.userRequests);
    const dispatch = useDispatch<AppDispatch>();
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [startDate, setStartDate] = useState<Date | null>( props.startDate || getDefaultDate(-6));
    const [endDate, setEndDate] = useState<Date | null>(props.endDate || getDefaultDate(6));
    const [status, setStatus] = useState<string>(props.status || "-1");
    const [filterType, setFilterType] = useState<string>(props.type || "0");
    const [successMsg, setSuccessMsg] = useState<string>("");
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [couponToCancel, setCouponToCancel] = useState<EmployeCoupons | null>(null);
    const [couponForFileViewing, setCouponForFileViewing] = useState<EmployeCoupons | null>(null);

    useEffect(() => {
        if (!cancelApprovedCouponResult) {
            return
        }
        if (cancelApprovedCouponResult.Success !== 1) {
            setErrorMsg("Ocurrió un error cancelando el cupón en el s10.");
            cleanCancelApprovedCouponData();
            return;
        }
        handleCancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cancelApprovedCouponResult])

    const cleanCancelApprovedCouponData = () => {
        dispatch(setLoadingCancelApprovedCoupon(false));
        dispatch(setCancelApprovedCouponData(undefined));
        dispatch(setCancelApprovedCouponResult(undefined));
        setCouponToCancel(null);
    }

    const CouponOptions = ({row}: any) => {
        return (
            <Grid container direction="row" minWidth={"2rem"} maxWidth={'4rem'}>
                {row.HasAttachment && <IconButton
                    aria-label="ver adjuntos"
                    onClick={() =>{
                        setCouponForFileViewing(row)
                    }}
                    style={{
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",

                        lineHeight: "1.25rem", 
                    }}
                >
                    <AttachFileIcon color={row.HasAttachment ? "primary" : "disabled"} />
                </IconButton>}
                {(row['StateDescription'] === "Pendiente" ) && // || row['StateDescription'] === "Aprobada"
                    <Tooltip
                        title="Cancelar"
                        slotProps={{
                            popper: {
                                modifiers: [
                                {
                                    name: 'offset',
                                    options: {
                                    offset: [0, -14],
                                    },
                                },
                                ],
                            },
                        }}
                    >
                        <IconButton
                            disabled={loading}
                            aria-label="Cancelar cupón"
                            onClick={!loading ? () => setCouponToCancel(row as any) : undefined }
                            style={{
                                minWidth: "2rem",
                                minHeight: "2rem",
                                padding: ".25rem"
                            }}
                        >
                            {loading 
                                ? <CircularProgress color="primary" size="1rem" />
                                : <DeleteIcon color="error" />
                            }
                        </IconButton >
                    </Tooltip>
                }
            </Grid>
        )
    }

    const employeeCouponsTableHeadRows = [
        {
            label: "Id",
            rowKeyName: "Id",
        },{
            label: "Uso",
            rowKeyName: "UseTypeDescription",
        },{
            label: "Fecha Solicitud",
            rowKeyName: "CreationDate",
        }, {
            label: "Rango",
            rowKeyName: "RangeDateInfo",
        },{
            label: "Cupón",
            rowKeyName: "Name",
        },{
            label: "Descripcion",
            rowKeyName: "Comments",
        },{
            label: "Estado",
            rowKeyName: "StateDescription",
        }, {
            label: "",
            rowKeyName: "cancel",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => <CouponOptions row={row} />,
        },
    ];

    const handleCancel = async () => {
        if (!couponToCancel) {
            return;
        }
        setLoading(true);
        const result = await setCancelCouponrequest(couponToCancel.Id);
        // TODO: hidden modal and refresh table row
        console.log(result);
        if (!result || result?.Type !== 0) {
            setErrorMsg(result?.Message || "Ocurrio un error anulando el cupón, por favor reintenta.")
        } else {
            setSuccessMsg(result.Message)
            handlerGetUserCoupons(true)
        }
        setLoading(false);
        cleanCancelApprovedCouponData();
    }

    const handleCancelApprovedCoupon = () => {
        if (!couponToCancel) {
            return;
        }
        console.log(couponToCancel)
        setLoading(true);
        dispatch(cancelApprovedCoupon(couponToCancel));
    }

    const handlerGetUserCoupons = (reset?: boolean) => {
        if (!companyselected || !connectionId) {
            return;
        }
        if (reset) {
            dispatch(resetCouponsSort());
        }
        const currentStartDate = getDefaultDate(-6)
        const currentEndDate = getDefaultDate(6)
        dispatch(searchEmployeeCoupons({
            quantity: itemsPerPage,
            // quantity: itemsPerPage,
            couponId: filterType as any,
            page: pageNumber || 1,
            status: status,
            startDate: getDatestring(startDate || currentStartDate),
            endDate: getDatestring(endDate || currentEndDate),
            onlyPendings: props?.onlyPendings,
        }));

    }

    useEffect(() => {
        handlerGetUserCoupons()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId, itemsPerPage, pageNumber, startDate, endDate, status, filterType, requestCoupon.flowId]);

    return (
        <>
        <MyTable
            tableHeadRows={employeeCouponsTableHeadRows}
            tableRows={props?.onlyPendings ? documents.couponsPendings  : documents.coupons}
            totalPages={props?.onlyPendings ? documents.couponsPendingsNumberOfPages  : documents.couponsNumberOfPages}
            totalItems={props?.onlyPendings ? documents.couponsPendingsTotalItems  : documents.couponsTotalItems}
            loading={documents.couponsLoading}
            
            cardComponent={{
                className:  (row) => row.State === CouponStatus.Aprobados
                                ? "coupon-appoved" 
                                : row.State === CouponStatus.Rechazados
                                    ? "coupon-rejected"
                                    : "coupon-pending",
                cardContent: (row) => {
                    return (
                        <CardContent style={{padding: "0 .5rem 1rem 1rem"}}>
                            <Grid container direction="row" alignItems="center" justifyContent="space-between">
                                <Grid item xs>
                                    <Typography variant="subtitle2" color="text.primary">
                                        {row.Name}
                                    </Typography>
                                </Grid>
                                <Grid item maxWidth="4rem" minWidth="2rem">
                                    <CouponOptions row={row} />
                                </Grid>
                            </Grid>
                            {row.CompanyName && <Grid item xs>
                                <Typography variant="subtitle2" color="text.primary" fontSize="12px">
                                    {row.CompanyName}
                                </Typography>
                            </Grid>}
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Estado: {" "}
                                <Typography variant="body2" component="span">
                                    {row.StateDescription}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Rango: {" "}
                                <Typography variant="body2" component="span">
                                    {row.RangeDateInfo}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Solicitado el: {" "}
                                <Typography variant="body2" component="span">
                                    {`${ formatDateToTimestamp(row.RequestDate || row.CreationDate)}`}
                                </Typography> 
                            </Typography> 
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Uso: {" "}
                                <Typography variant="body2" component="span">
                                    {row.UseTypeDescription}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Descripción: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Comments}
                                </Typography>
                            </Typography>
                            {/* <CouponOptions row={row} /> */}
                        </CardContent>
                    );
                },
                numberOfCards: props?.numberOfCards,
                changeViewOptionHidden: props?.changeViewOptionHidden,
            }}
            // hiddenDateRange={true}
            hiddenSearchInput={true}
            calculateLimitDate={false}
            onChangeItemsPerPage={setItemsPerPage}
            onChangePageNumber={setPageNumber}
            rangeControlProps={
                props.hiddenFilter
                ? undefined
                : {
                    startDate: startDate,
                    setStartDate: setStartDate,
                    endDate: endDate,
                    setEndDate: (value: SetStateAction<Date | null>) => {
                        setPageNumber(1);
                        setEndDate(value);
                        // handlerGetUserCoupons();
                    },
                }
            }
            selectControlProps={
                props.hiddenFilter
                ? undefined
                : {
                    label: "Estado",
                    onChange: (satus) => {
                        setPageNumber(1);
                        setStatus(satus);
                        // handlerGetUserCoupons();
                    },
                    options: [
                        {label: "Todos", value: !!props.status ? "-2" : "-1"},
                        {label: "Solicitados", value: "0"},
                        {label: "Aprobados", value: "1"},
                        {label: "Rechazados", value: "2"},
                        {label: "Usados y Rechazados", value: CouponStatus.UsadosYRechazados as any},
                        {label: "Pendientes y Aprovados", value: CouponStatus.PendientesYAprobados as any},
                    ],
                    value: status,
                }
            }
            customItemOptionBarMiddle={
                props.hiddenFilter
                ? undefined
                : () => 
                <FormControl style={{minWidth: "100%"}}>
                    <InputLabel id="select-option-label">Cupón</InputLabel>
                    <Select
                        labelId="select-option-label"
                        label="Cupón"
                        onChange={(event: { target: { value: string } }) => {
                            const value = event.target.value;
                            console.log("")
                            setFilterType(value);
                        }}
                        value={filterType || "0"}
                        style={{
                            height: "2rem", 
                            border: "none", 
                            backgroundColor: "white", 
                            width: "100%",
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis', // Enable ellipsis for text overflow
                        }}
                    >
                        <MenuItem 
                            value={"0"}
                        >
                            Todos
                        </MenuItem>
                        {requestCoupon?.couponsTypes?.map((item, i) => (
                            <MenuItem 
                                key={i} 
                                value={item.CouponId}
                            >
                                {item.CouponName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
            hiddenBottomPaginator={props?.hiddenBottomPaginator}
            tableOptionsBar={{
                useDrawer: true,
            }}
        />
        <Dialog
            open={couponToCancel !== null}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Cancelar solicitud
            </DialogTitle>
            <DialogContent style={{width: "100%"}}>
                <Grid container direction="column" style={{marginTop: "1.5rem", width: "100%"}}>
                    <Grid item>
                        <label 
                            style={{
                                color: "#666",
                                fontFamily: "Roboto",
                                fontSize: ".875rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                            }}
                        >
                            ¿Está seguro de cancelar el cupón solicitado?
                        </label>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"} spacing={2}>
                    <Grid item xs={6}>
                        <Button
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            disabled={loading}
                            onClick={() => {
                                if (loading) return;
                                setCouponToCancel(null);
                            }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            disabled={loading}
                            onClick={async () => {
                                if (loading) return;
                                if (couponToCancel?.StateDescription === "Aprobada") {
                                    await handleCancelApprovedCoupon();
                                } else {
                                    await handleCancel();
                                }
                            }}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
        <MySnackbar
            open={successMsg !== ""}
            severity="success"
            onClose={() => setSuccessMsg("")}
            msg={successMsg}
        />
        <MySnackbar
            open={errorMsg !== ""}
            severity="error"
            onClose={() => setErrorMsg("")}
            msg={errorMsg}
        />
        {couponForFileViewing !== null && <Dialog
            key={couponForFileViewing.FilesGroup}
            maxWidth="md"
            
            open={couponForFileViewing !== null}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
            PaperProps={{
                style: {
                width: '80%',
                // maxWidth: '600px',   // Máximo ancho del Dialog
                }
            }}
            fullWidth
        
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Documentos
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <DocumentsComponent 
                    groupId={couponForFileViewing.FilesGroup} 
                    allowToDeleteFiles={true} 
                    afterDeleteFileAction={async (deletedFileId, remainingFiles) => {
                        await setCouponsHasAttachmentFlag(couponForFileViewing.Id, remainingFiles > 0)
                    }}
                    afterUploadFileAction={async (deletedFileId, remainingFiles) => {
                        await setCouponsHasAttachmentFlag(couponForFileViewing.Id, remainingFiles > 0)
                    }}
                    allowToAddFiles={true}
                />
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={12} textAlign={"right"}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setCouponForFileViewing(null)}
                        >
                            Cerrar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}
        </>
    )
}

export default TableCoupons;